import { PropsWithChildren } from "react";

import { WagmiProvider } from "wagmi";

import { config } from "./app-kit-config";
import { config as wagmiConfig } from "./config";

const wallet = import.meta.env.VITE_WALLET;
const cfg = wallet === "appkit" ? config : wagmiConfig;

console.log(wallet);

export type Config = typeof cfg;
export const Provider = ({ children }: PropsWithChildren) => {
  return <WagmiProvider config={cfg}>{children}</WagmiProvider>;
};

declare module "wagmi" {
  interface Register {
    config: Config;
  }
}
